import { Component } from 'react';
import moment from 'moment';
import { PATIENT_VALIDATED, PATIENT_NOT_VALIDATED, PATIENT_BLOCKED } from 'services/constants';
import { parseToValidPhone } from 'services/phoneNumber';

// Styles && Images
import DefaultProfileBg from 'assets/images/default-profile.svg';
import * as styles from './styles';

function trim(value) {
  if (value) return value.trim();
  return value;
}

const statuses = {
  [PATIENT_NOT_VALIDATED]: 'not_verified_user',
  [PATIENT_BLOCKED]: 'blocked_user'
};

class Patient extends Component {
  render() {
    const { profile = {}, i18n, patient = {}, openVerifyModal, note } = this.props;
    const { insurance = {}, generalPractitioner, status: patientStatus } = profile.umbi || {};

    return (
      <div>
        {/* ──── Patient info ───────────────────────────────────────────────────────────────── */}
        <styles.APT_Section>
          {/* left section */}
          <styles.APT_PatientSection>
            <styles.APT_ImgWrapper>
              {patient.isUmbi && <styles.APT_ColorCircleInformer className={patientStatus} />}
              <img src={patient.photo || DefaultProfileBg} alt="patient image" />
            </styles.APT_ImgWrapper>

            <div>
              <p>
                {`${trim(patient.firstName)} ${trim(patient.lastName)}`}
                {patientStatus !== PATIENT_VALIDATED && (
                  <span className={patientStatus}>
                    {i18n.t(statuses[patientStatus]).toUpperCase()}
                  </span>
                )}
              </p>

              <div className="patient-info">
                <div>
                  <span>{i18n.t('birth_date')}</span>
                  <div>
                    {patient.birthDate
                      ? moment(patient.birthDate).format('DD.MM.YYYY')
                      : i18n.t('no_data')}
                  </div>
                </div>

                <div>
                  <span>{i18n.t('gender')}</span>
                  <div>
                    {i18n.t(patient.gender ? `gender_${patient.gender.toLowerCase()}` : 'no_data')}
                  </div>
                </div>

                {patientStatus === PATIENT_NOT_VALIDATED && (
                  <button onClick={openVerifyModal}>{i18n.t('verify_patient_button')}</button>
                )}
              </div>
            </div>
          </styles.APT_PatientSection>

          {/* right section */}
          <div>
            <div>
              <span>{i18n.t('internal_id')}</span>
              <div>{trim(patient.externalId) || i18n.t('no_data')}</div>
            </div>
            <div>
              <span>{i18n.t('hospital_id')}</span>
              <div>{trim(profile.number) || i18n.t('no_data')}</div>
            </div>
          </div>
        </styles.APT_Section>

        {/* ──── Row 2 ──────────────────────────────────────────────────────────────────────── */}
        <styles.APT_Section>
          {/* left section */}
          <div>
            <div>
              <span>{i18n.t('email')}</span>
              <div>
                {trim(profile.email) || i18n.t('no_data')}{' '}
                <styles.APT_ServiceInfo> | UG</styles.APT_ServiceInfo>
              </div>
              <div>
                {trim(profile.umbi && profile.umbi.email) || i18n.t('no_data')}{' '}
                <styles.APT_ServiceInfo> | UMBI</styles.APT_ServiceInfo>
              </div>
            </div>
            <div>
              <span>{i18n.t('mobile_phone')}</span>
              <div>
                {profile.phone ? parseToValidPhone(profile.phone) : i18n.t('no_data')}
                <styles.APT_ServiceInfo> | UG</styles.APT_ServiceInfo>
              </div>
              <div>
                {profile.umbi && profile.umbi.phone
                  ? parseToValidPhone(profile.umbi.phone)
                  : i18n.t('no_data')}
                <styles.APT_ServiceInfo> | UMBI</styles.APT_ServiceInfo>
              </div>
            </div>
            <div>
              <span>{i18n.t('address')}</span>
              <div>{trim(profile.address) || i18n.t('no_data')}</div>
            </div>
          </div>

          {/* right section */}
          <div>
            <div>
              <span>{i18n.t('language')}</span>
              <div>{trim(profile.language) || i18n.t('no_data')}</div>
            </div>
            <div>
              <span>{i18n.t('nationality')}</span>
              <div align="left">{trim(profile.nationality) || i18n.t('no_data')}</div>
            </div>
          </div>
        </styles.APT_Section>

        {/* ──── Row 3 ──────────────────────────────────────────────────────────────────────── */}
        <styles.APT_Section>
          {/* left section */}
          <div>
            <div>
              <span>{i18n.t('insurance_company')}</span>
              <div>{(insurance.company && insurance.company.name) || i18n.t('no_data')}</div>
            </div>
            <div>
              <span>{i18n.t('insurance_contract')}</span>
              <div>
                {`${(insurance.contractType && insurance.contractType.name) ||
                  i18n.t('no_data')}  | ${insurance.contractNumber || i18n.t('no_data')}`}
              </div>
            </div>
          </div>

          {/* right section */}
          <div>
            <div>
              <span>{i18n.t('general_practitioner')}</span>
              <div>{trim(generalPractitioner) || i18n.t('no_data')}</div>
            </div>
          </div>
        </styles.APT_Section>

        {/* ──── Row 4 ──────────────────────────────────────────────────────────────────────── */}
        <styles.APT_Section>
          {/* left section in full width*/}
          <div className="full-width">
            <div>
              <span>{i18n.t('note')}</span>
              <div>{trim(note) || i18n.t('no_data')}</div>
            </div>
          </div>
        </styles.APT_Section>
      </div>
    );
  }
}

export default Patient;
